import React from "react";
import AOS from "aos";
import "aos/dist/aos.css"; // You can also use <link> for styles
const About = () => {
  AOS.init();
  return (
    <section
      className="px-[3%] grid grid-cols-1 lg:grid-cols-2 gap-[6%] pt-[40px]"
      id="about"
    >
      <div
        className="flex flex-col gap-5"
        data-aos="fade-right"
        data-aos-duration="1100"
      >
        <h2 className="font-extrabold whitespace-nowrap text-[70px] sm:text-[90px] bg-gradient-to-r from-[#00ff85] to-[#00dbff] text-transparent bg-clip-text">
          About Me
        </h2>
        <div className="flex flex-col gap-2 font-sans leading-6">
          <p>
            Hello! I am a front-end web developer with over 3 years of
            experience, specializing in front-end development. My skill set
            includes HTML, CSS, JavaScript, TypeScript, ReactJS, Redux, NodeJS,
            MySQL, Firebase, CI/CD setup, and web server deployment.
          </p>
          <p>
            I had the opportunity to work at FPTS, a company in the securities
            industry. During my time there, I took on the role of a front-end
            developer, where I was responsible for pixel-perfect UI coding and
            optimizing the performance of large-scale data-driven applications.
          </p>
          <p>
            I then continued my journey at Enuy, where I contributed to the
            development of products related to human resource management,
            training, resource management, and task management. There, I not
            only honed my front-end skills but also became proficient in
            configuring CI/CD with GitLab Runner and deploying web applications
            to servers.
          </p>
          <p>
            I am committed to writing clean, SEO-friendly code that is optimized
            for performance. I take pride in the work I do and strive to deliver
            the best possible web experiences. You can learn more about my work
            on{" "}
            <a
              href="https://github.com/duchaidev"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#00ff85]"
            >
              Github
            </a>{" "}
            or feel free to{" "}
            <a
              href="https://www.linkedin.com/in/duchaidev/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#00ff85]"
            >
              Contact me
            </a>{" "}
            directly for further discussion.
          </p>
        </div>
      </div>
      <div className="flex flex-col gap-8">
        <div
          className="flex gap-[10px] flex-col"
          data-aos="fade-left"
          data-aos-delay="150"
          data-aos-duration="600"
        >
          <span className="text-[20px]">HTML/CSS</span>
          <p className="w-full h-[6px] bg-[#444444] relative">
            <span className="w-[80%] h-full bg-[#00ff85] absolute top-0 left-0">
              <span className="absolute text-sm -right-6 top-3">3 Years</span>
            </span>
          </p>
        </div>
        <div
          className="flex gap-[10px] flex-col"
          data-aos="fade-left"
          data-aos-delay="250"
          data-aos-duration="600"
        >
          <span className="text-[20px]">ReactJs</span>
          <p className="w-full h-[6px] bg-[#444444] relative">
            <span className="w-[62%] h-full bg-[#00dbff] absolute top-0 left-0">
              <span className="absolute text-sm -right-6 top-3">2.5 Years</span>
            </span>
          </p>
        </div>
        <div
          className="flex gap-[10px] flex-col"
          data-aos="fade-left"
          data-aos-delay="350"
          data-aos-duration="600"
        >
          <span className="text-[20px]">Nodejs</span>
          <p className="w-full h-[6px] bg-[#444444] relative">
            <span className="w-[30%] h-full bg-[#fff] absolute top-0 left-0">
              <span className="absolute text-sm -right-6 top-3">
                Over 1 Years
              </span>
            </span>
          </p>
        </div>

        <div
          className="grid grid-cols-1 gap-5 mt-8 xl:grid-cols-2"
          data-aos="fade-left"
          data-aos-delay="450"
          data-aos-duration="600"
        >
          <div className="flex flex-col bg-[#1d1d1d] p-6 rounded-md gap-2">
            <h2 className="text-[24px]">Frontend Developer</h2>
            <span className="font-semibold mt-4 text-[#00ff85]">
              FPT Securities JSC - FPTS
            </span>
            <span className="text-[14px]">05/2022 - 08/2023</span>
            <span className="mt-3 leading-5">
              Optimized front-end performance and delivered pixel-perfect UI for
              data-driven applications in the securities sector.
            </span>
          </div>
          <div className="flex flex-col bg-[#1d1d1d] p-6 rounded-md gap-2">
            <h2 className="text-[24px]">Frontend Developer</h2>
            <span className="font-semibold mt-4 text-[#00ff85]">Enuy Corp</span>
            <span className="text-[14px]">12/2023 - Present</span>
            <span className="mt-3 leading-5">
              Developed user-friendly interfaces for HR and task management
              tools. Configured CI/CD pipelines with GitLab Runner and Docker,
              managing deployments to ensure efficient application performance.
            </span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
